<div class="toast-stack" role="region" aria-label="Notifications" aria-live="polite">
  @for (toast of toasts.toasts(); track toast.id) {
    <article class="toast" [attr.data-type]="toast.type" role="alert">
      <div class="toast-icon">
        <app-icon [name]="iconFor(toast.type)" [size]="18" aria-hidden="true" />
      </div>
      <div class="toast-body">
        <div class="toast-title">{{ toast.title }}</div>
        @if (toast.message) {
          <div class="toast-message">{{ toast.message }}</div>
        }
      </div>
      <button
        type="button"
        class="toast-dismiss focus-ring"
        [attr.aria-label]="'Dismiss ' + toast.title"
        (click)="dismiss(toast.id)"
      >
        <app-icon name="close" [size]="14" aria-hidden="true" />
      </button>
    </article>
  }
</div>
